import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './assets/app.scss'
import VueI18n from 'vue-i18n'
import { currency } from './helpers/customfilters'

Vue.use(VueI18n)
// Vue.use(vuemoment)
Vue.use(require('vue-moment'))

Vue.use(Vuetify, {
  // theme: {
  //   primary: '#1ABC9C',
  //   secondary: '#e5e5e5',
  //   third: '#FFF',
  //   accent: '#414551',
  //   error: '#F17288',
  //   info: '#404551',
  //   success: '#1ABC9C',
  //   warning: '#FFC107',
  //   background: '#F5F5F5'
  // }
})

Vue.config.productionTip = false

/* eslint-disable no-new */

var i18n = new VueI18n({
  locale: 'se'
})

Vue.moment.updateLocale('en', {
  months: [
    'January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'
  ]
})

Vue.moment.updateLocale('se', {
  months: [
    'Januari', 'Februari', 'March', 'April', 'Maj', 'Juni', 'Juli',
    'Augusti', 'September', 'Oktober', 'November', 'December'
  ]
})

// Vue.moment.locale('sv')

Vue.filter('fixed', function (value) {
  if (!value && value !== 0) return ''
  return value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
})

Vue.filter('dateonly', function (value) {
  if (!value && value !== 0) return ''
  return Vue.moment(value).format('YYYY-MM-DD')
})

Vue.filter('short', function (value) {
  if (!value && value !== 0) return ''
  return Vue.moment(value).format('YYYY-MM-DD HH:mm')
})

Vue.filter('long', function (value) {
  if (!value && value !== 0) return ''
  return Vue.moment(value).format('D MMMM YYYY HH:mm')
})

Vue.filter('time', function (value) {
  if (!value && value !== 0) return ''
  return Vue.moment(value).format('HH:mm')
})

Vue.filter('currency', currency)

new Vue({
  i18n,
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js